<template>
  <b-modal
    id="modal-download-history"
    :title="$t('report.title.downloadHistory')"
    class="mc-modal"
    size="xl"
    centered
    scrollable
    ok-variant="outline-primary"
    :ok-title="$t('global.action.close')"
    title-class="text-white"
    header-close-variant="light"
    ok-only
  >
    <div id="tickets-table_filter" class="dataTables_filter text-end">
      <label
        class="d-inline-flex align-items-center mc-table-view__search ms-2"
        @click="focusSearch"
      >
        <i class="mc-fa fas fa-search"></i>
        <b-form-input
          v-model="filter"
          type="search"
          :placeholder="$t('global.search') + '...'"
          class="ms-2"
          ref="searchInput"
        />
      </label>
    </div>

    <div class="table-responsive my-3 border border-1">
      <b-table
        ref="downloadHistoryRef"
        :items="downloadHistoryList"
        :fields="fields"
        empty-table
        show-empty
        :busy="$apollo.queries.downloadHistory.loading && isRefresh"
        @filtered="onFiltered"
        :empty-text="$t('global.emptyTable')"
        :empty-filtered-text="$t('global.emptyFilteredTable')"
        :per-page="perPage"
        :filter="filter"
        :current-page="currentPage"
        class="datatables"
        responsive="md"
        :tbody-tr-class="rowClass"
      >
        <template #table-busy>
          <div class="text-center my-2">
            <b-spinner class="align-middle" />
          </div>
        </template>
        <template #cell(title)="data">
          <div class="d-flex align-items-center gap-1">
            <span>{{ data.item.title }}</span>
            <i
              :id="`too-big-tooltip-${data.item.downloadHistoryId}`"
              class="icon-outline_info"
              v-if="getDownloadCondition(data.item) == 'I' && data.item.isHuge"
            ></i>
            <b-tooltip
              :target="`too-big-tooltip-${data.item.downloadHistoryId}`"
              triggers="hover"
              placement="right"
              custom-class="formulate-input-tooltip"
            >
              {{ $t('report.text.tooBigReport') }}
            </b-tooltip>
          </div>
        </template>
        <template #cell(downloadOn)="data">
          {{ momentDateShortMonth(data.item.downloadOn) }}
          <br />
          <span class="text-secondary">
            {{ momentTime(data.item.downloadOn) }}
          </span>
        </template>

        <template #cell(typeCode)="data">
          {{ data.item.typeCode.charAt(0) == 'T' ? 'Tabel' : 'Grafik' }}
          <br />
          <span class="text-secondary">
            {{
              data.item.typeCode.charAt(1) == 'P'
                ? 'PDF'
                : data.item.typeCode.charAt(1) == 'E'
                ? 'Excel'
                : 'CSV'
            }}
          </span>
        </template>

        <template #cell(periode)="data">
          {{ momentDateShortMonth(data.item.startDate) }} -
          {{ momentDateShortMonth(data.item.endDate) }}
        </template>

        <template #cell(progress)="data">
          {{ getProgressDownloaded(data.item.url) }}
        </template>

        <template #cell(action)="data">
          <a
            class="btn btn-outline-primary btn-sm"
            v-if="getDownloadCondition(data.item) == 'D'"
            @click="downloadHistory(data.item.url)"
            ><i class="fas fa-download"></i> {{ $t('global.action.download') }}
          </a>
          <div v-else-if="getDownloadCondition(data.item) == 'F'">
            <small class="text-danger">{{ $t('global.action.failedDownload') }}</small>
          </div>
          <div v-else>
            <small>{{ $t('global.action.downloading') }}..</small>
          </div>
        </template>
      </b-table>
    </div>
    <div class="row mt-3">
      <div class="col-sm-12 col-md-6">
        <div id="tickets-table_length" class="dataTables_length">
          <label class="d-inline-flex align-items-center">
            {{ $t('global.text.displays') }}
            <b-form-select
              class="form-select form-select-sm"
              v-model="perPage"
              size="sm"
              :options="pageOption"
            />
            {{ $t('global.text.entries') }}
            .
            <p>
              {{ $t('global.text.displays') }}
              <strong>{{ filteredItems.length > 0 ? (currentPage - 1) * perPage + 1 : 0 }}</strong>
              -
              <strong>{{ Math.min(filteredItems.length, currentPage * perPage) }}</strong
              >&nbsp;{{ $t('global.object.of') }}&nbsp;<strong>{{ filteredItems.length }}</strong>
            </p>
          </label>
        </div>
      </div>
      <div class="col-sm-12 col-md-6">
        <div class="dataTables_paginate paging_simple_numbers float-end">
          <ul class="pagination pagination-rounded mb-0">
            <!-- pagination -->
            <b-pagination v-model="currentPage" :total-rows="totalRows" :per-page="perPage" />
          </ul>
        </div>
      </div>
    </div>
  </b-modal>
</template>
<script>
import { Helper } from '@/mixin/helper'
import { GET_DOWNLOAD_HISTORIES } from '@/services/api/report/report'
export default {
  mixins: [Helper],
  apollo: {
    downloadHistory: {
      query: GET_DOWNLOAD_HISTORIES,
      variables() {
        return {
          filter: {
            orderBy: [JSON.stringify({ downloadOn: 'desc' })],
          },
        }
      },
      manual: true,
      fetchPolicy: 'no-cache',
      result({ data, loading }) {
        if (!loading) {
          this.initData(data)
        }
      },
      error(error) {
        console.log('errors', error.graphQLErrors)
      },
    },
  },
  destroyed() {
    clearInterval(this.interval)
  },
  data() {
    return {
      downloadHistories: [],
      filteredItems: [],
      filter: null,
      totalRows: 1,
      currentPage: 1,
      perPage: 10,
      pageOption: [10, 25, 50, 100],
      downloadId: null,
      interval: null,
      isRefresh: true,
      currentCountInterval: 0,
      maxIntervalLoop: 10,
      currentSecondInterval: 20,
      incrementInterval: 10,
    }
  },
  computed: {
    fields() {
      return [
        {
          key: 'title',
          label: this.$t('report.object.reportTitle'),
        },
        {
          key: 'periode',
          label: this.$t('report.object.reportPeriod'),
        },
        {
          key: 'downloadOn',
          label: this.$t('report.object.downloadDate'),
        },
        {
          key: 'typeCode',
          label: this.$t('global.object.type'),
        },
        {
          key: 'progress',
          label: this.$t('global.object.progress'),
        },
        {
          key: 'action',
          label: '',
        },
      ]
    },
    downloadHistoryList() {
      return this.downloadHistories
    },
  },
  watch: {
    currentCountInterval(value) {
      if (value == this.maxIntervalLoop) {
        this.currentSecondInterval += this.incrementInterval
        clearInterval(this.interval)
        this.intervalCheckingReport()
      }
    },
    downloadHistories(value) {
      const pendingHistory = value.filter((item) => this.getDownloadCondition(item) == 'I')
      if (pendingHistory.length <= 0) {
        clearInterval(this.interval)
      }
    },
  },
  methods: {
    intervalCheckingReport() {
      this.currentCountInterval = 0
      this.interval = setInterval(async () => {
        await this.$apollo.queries.downloadHistory.refetch()
        this.currentCountInterval++
      }, this.currentSecondInterval * 1000)
    },

    focusSearch() {
      this.$refs.searchInput.focus()
    },

    rowClass(item, type) {
      if (item && type === 'row') {
        if (item.downloadHistoryId == this.downloadId) {
          return 'table-active'
        } else {
          return ''
        }
      } else {
        return ''
      }
    },
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.filteredItems = filteredItems
      this.totalRows = filteredItems.length
      this.currentPage = 1
    },
    initData(data) {
      if (this.isRefresh) {
        this.downloadHistories = data.downloadHistory.downloadHistory
        this.filteredItems = data.downloadHistory.downloadHistory
        this.totalRows = data.downloadHistory.downloadHistory?.length
        this.isRefresh = false
      } else {
        const dataHistory = data.downloadHistory.downloadHistory
        const pendingHistory = this.downloadHistories.filter(
          (item) => this.getDownloadCondition(item) == 'I'
        )
        if (pendingHistory.length <= 0) {
          clearInterval(this.interval)
          return
        }
        for (const dh of pendingHistory) {
          const findIndex = this.downloadHistories.findIndex(
            (item) => item.downloadHistoryId == dh.downloadHistoryId
          )
          const download = dataHistory.find(
            (item) => item.downloadHistoryId == dh.downloadHistoryId
          )
          if (download) {
            this.downloadHistories[findIndex] = download
          }
        }
        this.$refs.downloadHistoryRef.refresh()
      }
    },
    refreshData() {
      self.isRefresh = true
      this.$apollo.queries.downloadHistory.refetch()
    },
    toDownloadHistory(downloadId) {
      const self = this
      self.isRefresh = true
      self.downloadId = downloadId
      this.$apollo.queries.downloadHistory.refetch()
      self.intervalCheckingReport()
      self.$bvModal.show('modal-download-history')
    },
    getDownloadCondition(item) {
      if (
        item.status == 'D' &&
        item.url &&
        item.url.length > 0 &&
        item.url.filter((u) => u !== null).length === item.url.length
      ) {
        return 'D'
      } else if (
        item.status === 'F' ||
        (item.status === 'I' &&
          new Date().getTime() - new Date(item.downloadOn).getTime() > 1000 * 3600 * 12)
      ) {
        return 'F'
      } else {
        return 'I'
      }
    },
    getProgressDownloaded(urls) {
      if (urls && urls.length > 0) {
        return `${urls.filter((url) => url !== null).length} / ${urls.length}`
      } else {
        return '0 / 1'
      }
    },
    downloadHistory(urls) {
      const downloadFileWithAnchor = (url) => {
        const anchor = document.createElement('a')
        anchor.href = url
        anchor.download = url.substring(url.lastIndexOf('/') + 1)
        document.body.appendChild(anchor)
        anchor.click()
        document.body.removeChild(anchor)
      }
      if (urls && urls.length > 0) {
        const urlsFinal = urls.filter((item) => item !== null && item.length > 0)
        const timeout = urlsFinal.length > 1 ? Math.ceil(urlsFinal.length / 2) * 1000 : 1000
        for (let index = 0; index < urlsFinal.length; index++) {
          setTimeout(() => {
            downloadFileWithAnchor(urlsFinal[index])
          }, timeout * index)
        }
      }
    },
  },
}
</script>
